var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMySecurityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,2 C15.2650527,2 17.5069252,4.24314436 17.5069252,7.01039501 L17.506,9.484 L17.901662,9.48440748 C19.0097033,9.48440748 19.9178539,10.3449783 19.9947289,11.4342975 L20,11.5841996 L20,19.9002079 C20,21.0095701 19.140257,21.917845 18.0514905,21.9947284 L17.901662,22 L7.09833795,22 C5.99005436,22 5.08212507,21.1399582 5.00526975,20.050179 L5,19.9002079 L5,11.5841996 C5,10.4753904 5.85997483,9.56661055 6.9485397,9.48968226 L7.09833795,9.48440748 L7.493,9.484 L7.49307479,7.01039501 C7.49307479,4.24286944 9.734391,2 12.5,2 Z M17.901662,10.3575884 L7.09833795,10.3575884 C6.4641227,10.3575884 5.94173136,10.8406758 5.87890985,11.4588638 L5.87257618,11.5841996 L5.87257618,19.9002079 C5.87257618,20.5353414 6.35504713,21.0576759 6.97303606,21.1204867 L7.09833795,21.1268191 L17.901662,21.1268191 C18.536178,21.1268191 19.0583062,20.6441805 19.1210937,20.0256279 L19.1274238,19.9002079 L19.1274238,11.5841996 C19.1274238,10.9072345 18.5781583,10.3575884 17.901662,10.3575884 Z M12.5,14.2656965 C13.3141296,14.2656965 13.9750693,14.9274595 13.9750693,15.7417879 C13.9750693,16.5567148 13.3143625,17.2178794 12.5,17.2178794 C11.6856375,17.2178794 11.0249307,16.5567148 11.0249307,15.7417879 C11.0249307,14.9274595 11.6858704,14.2656965 12.5,14.2656965 Z M12.5,15.1388773 C12.1678888,15.1388773 11.8975069,15.4095961 11.8975069,15.7417879 C11.8975069,16.0744703 12.1675481,16.3446985 12.5,16.3446985 C12.8324519,16.3446985 13.1024931,16.0744703 13.1024931,15.7417879 C13.1024931,15.4095961 12.8321112,15.1388773 12.5,15.1388773 Z M12.5,2.87318087 C10.2163015,2.87318087 8.36565097,4.72511392 8.36565097,7.01039501 L8.36565097,9.48440748 L16.634349,9.48440748 L16.634349,7.01039501 C16.634349,4.72541339 14.7831667,2.87318087 12.5,2.87318087 Z",
    id: "icons/apps/my-security--path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icons/apps/my-security--mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icons/apps/my-security--path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#icons/apps/my-security--path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icons/apps/my-security--mask-2)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySecurityIcon);
export default __webpack_public_path__ + "static/media/my-security-icon.a71101c9.svg";
export { ForwardRef as ReactComponent };